import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'

import type { LoggedUser, UserPermissions } from '@/api/auth/types/LoggedUser'
import { QUERY_KEYS } from '@/lib/queryKeys'
import { getCurrentUser } from '@/services/users'
import type { RootState } from '@/store/store'

export const useCurrentUser = () => {
  const isAuthenticated = useSelector((state: RootState) => state.app.isAuthenticated)

  return useQuery({
    queryKey: [QUERY_KEYS.LOGGED_USER],
    enabled: isAuthenticated,
    queryFn: getCurrentUser,
    select: (data: LoggedUser) => {
      return {
        ...data,
        permissions: {
          ...(data?.permissions || {}),
          ...data?.groups?.Groups.reduce((acc, group) => {
            acc[group.GroupName] = true
            return acc
          }, {} as UserPermissions),
        },
      }
    },
  })
}
